export default __webpack_public_path__ + "static/media/northern_cyprus.8260b4e4.svg";